import Header from '../components/Header';
import { WomensAndMentalHealthSurvey } from '../components/Surveys';

export function SurveyWomensAndMentalPage() {
  return (
    <div className="mainAppContainer">
      <div className="pageContainer">
        <Header long={true} includeBackButton={true} />
        <WomensAndMentalHealthSurvey />
      </div>
    </div>
  );
}

export default SurveyWomensAndMentalPage;
